module.exports = __webpack_public_path__ + "img/BuE DS Logo public Installation.405fc23a.png";